import * as React from 'react';

import { DialogAlertStyles } from '~src/common/react/components/dialogAlerts/DialogAlertStyles';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { classes, cssClass } from '~src/style';

const rootClass = 'WarningBanner';

const borderRadiusValue: string = '4px';

const bannerWrapper = cssClass(rootClass, 'bannerWrapper', {
  display: 'flex',
  padding: 12,
  borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`,
});

const errorIconStyle = cssClass(rootClass, 'errorIconStyle', {
  marginRight: 8,
});

export interface WarningBannerProps {
  message: string;
}

export function WarningBanner(props: WarningBannerProps): JSX.Element {
  return (
    <div className={classes(bannerWrapper, DialogAlertStyles.warningStyle)}>
      <img src={imgPath('common_alert_warning.svg')} alt={''} className={errorIconStyle} />
      {props.message}
    </div>
  );
}
